import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'

const ErrorPage = lazy(() => import('./ErrorPage/ErrorPage'))

export default {
  path: '/no-account-found',
  exact: false,
  Component: WithPermission(ErrorPage, [], true),
  access: 'PUBLIC',
}
